import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ReactJsonEditor from '../../../../../../components/ReactJsonEditor';
import '../../../../../../assets/jsonEditor.css';
import { memo } from 'react';

function RulesEditor({ rules, setRef }) {
  return (
    <Row className="align-items-start">
      <Col md={12}>
        <ReactJsonEditor value={rules} getJsonEditor={jsonEditor => setRef(jsonEditor)} />
      </Col>
    </Row>
  );
}

export default memo(RulesEditor);
